import { TValidSdcColumns } from './../../sdc-columns.type';
import { DEFAULT_SORT } from './../default-sort.constant';
import { sdcStateConfigConstant } from './../sdc-state-config.constant';
import {
  IColumnSort,
  IFilter,
  IGridViews,
  ISdcActivity,
  TValidSdcStates,
  TValidSdcViews,
} from './../sdc-state.typings';

export class DefaultSdcConfigService implements ISdcActivity {
  get humanName() {
    return sdcStateConfigConstant.DEFAULT_SDC.humanName;
  }

  get state(): TValidSdcStates {
    return sdcStateConfigConstant.DEFAULT_SDC.state;
  }

  get columns(): TValidSdcColumns[] {
    return [
      'studentId',
      'studentName',
      'cohort',
      'status',
      'grade',
      'learningPreference',
      'officialClass',

      // Per requirements on https://newvisions.atlassian.net/browse/PFD-7449 , keep this code until further notice.
      // regents exemptions
      // 'countOfRegentsReqsNeededForExemptionCourseworkCompleted',
      // 'countOfRegentsReqsNeededForExemptionCourseworkInProgress',
      // 'countOfRegentsReqsNeededNotEligibleForExemption',
      // 'countOfRegentsExamsIdentifiedForExemption',
      // 'countOfRegentsExamsWithCourseworkCompleted',
      // 'countOfRegentsExamsWithCourseworkInProgress',
      // 'countOfRegentsExamsWithCourseworkInProgressDOE',
      // 'countOfRegentsExamsGreaterThan55',

      // google classroom
      'classroomRemoteEngagementLast5',
      'classroomRemoteEngagement',
      'classroomTotalAssignments',
      'classroomTotalEngagedAssignments',
      'classroomTotalEnrolled',
      'classroomStudentEmail',

      'dob',
      'sendingSchool',
      'admitDate',
      'dischargeCode',
      'dischargeDate',
      'gender',
      'ethnicity',
      'citywideLowestThird',

      'seniorFlag',
      'ageOn1231OfCurrentSy',
      'yearOfEntry',
      'countOfAdmitsToCurrentSchool',
      'overageUnderCredited',
      'mostAtRisk',

      'iep',
      'spedProgram',
      'potentiallyEligibleForSafetyNet',
      'schoolVerifiedSafetyNetEligibility',
      'isSafetyNetEligible',
      'sife',
      'ell',
      'homeLanguage',
      'lepStatus',

      'plannedDiplomaType',
      'plannedGraduationDate',
      'gradPlan',
      'creditsBehind',
      'regentsBehind',
      'distanceFromGraduation',

      'elaPr8thGrade',
      'mathPr8thGrade',

      'transitDistanceMiles',
      'transitTimeMinutes',
      'attendancePriorSy',
      'attendancePreviousSchoolDay',
      'attendanceYtdFilter',
      'attendanceYtd',
      'inPersonYTDAttendance',
      'remoteYTDAttendance',
      'attendanceYtdLastYear',
      'ytdAttendanceChange',
      'attendanceLast20',
      'inPersonAttendanceLast20Days',
      'remoteAttendanceLast20Days',
      'attendanceLast20MinusYtdPct',
      'numberOfDaysAbsentYtd',
      'countOfInPersonDaysAbsentYTD',
      'countOfInRemoteDaysAbsentYTD',
      'numberOfDaysAbsentLast5Days',
      'countOfInPersonDaysAbsentLast5Days',
      'countOfRemoteDaysAbsentLast5Days',
      'countOfDaysAbsentLast10Days',
      'countOfInPersonDaysAbsentLast10Days',
      'countOfRemoteDaysAbsentLast10Days',
      'numberOfDaysAbsentLast20Days',
      'countOfInPersonDaysAbsentLast20Days',
      'countOfRemoteDaysAbsentLast20Days',
      'countOfDaysAbsentThisTerm',
      'countOfInPersonDaysAbsentThisTerm',
      'countOfRemoteDaysAbsentThisTerm',
      'percentDaysLateYtd',
      'percentDaysLatePriorSy',
      'sepAttendance',
      'octAttendance',
      'novAttendance',
      'decAttendance',
      'janAttendance',
      'febAttendance',
      'marAttendance',
      'aprAttendance',
      'mayAttendance',
      'junAttendance',
      'countOfCurrentlyActiveAttendanceSupports',
      'currentlyActiveAttendanceSupports',

      'currentCourses',
      'currentCourseCodes',
      'countOfCoursesFailingMostRecentMp',
      'countOfHighPriorityCoursesFailingMostRecentMp',

      'totalCreditsAttempted',
      'totalCreditsEarned',
      'totalCreditsSched',
      'avg8thGradeGpa',
      'transcriptGradeAverage',
      'creditsEarnedPriorToCurrentSy',
      'totalCreditsEarnedToDateInCurrentSy',
      'countOfFailedCoursesInCurrentSy',
      'countOfCurrentlyActiveAcademicSupports',
      'currentlyActiveAcademicSupports',

      'countOfRegentsPassedForDiploma',
      'regentsPassedForDiploma',
      'countOfRegentsNeededForOnTrackDiploma',
      'regentsNeededForOnTrackDiploma',
      'regentsNeededForCollegeReadiness',
      'countOfRegentsPassedForGrad',
      'countOfRegentsPassedAt65Of5',
      'countOfRegentsPassedAt55Of5SpedOnly',
      'countOfRegentsPassedAt65Of9',
      'countOfRegentsPassedOf5PriorToCurrentSy',
      'countOfCurrentlyActiveRegentsPrepSupports',
      'currentlyActiveRegentsPrepSupports',

      'collegeReadyOnMathRegentsOrSatMath',
      'collegeReadyOnElaRegentsOrSatCr',

      'countOfCurrentlyActiveSupports',
      'currentlyActiveSupports',

      'atsCounselor',
      'atsCounselorEmail',
      'guidanceCounselor',
      'advisor',

      // added for community schools on 3/22
      'schoolPriorityFlag',
    ];
  }

  get hiddenColumns(): TValidSdcColumns[] {
    return [];
  }

  get gridViews(): IGridViews {
    return {};
  }

  get filter(): IFilter {
    return {
      status: ['A'],
    };
  }

  get sort(): IColumnSort[] {
    return DEFAULT_SORT;
  }

  get bundleName() {
    return 'DEFAULT_SDC';
  }

  get availableSdcViews(): TValidSdcViews[] {
    return sdcStateConfigConstant.DEFAULT_SDC.availableSdcViews;
  }
}
